module.exports = __webpack_public_path__ + "components/flag/static/square/pr-9bfdc93f58dd37c22d3b1e5b6732f7e6.svg";